import { useMemo } from "react";
import { useSearchParams as useRRSearchParams } from "react-router-dom";

/**
 * Next.js-shaped useSearchParams hook for cockpit.
 *
 * In Next.js, `useSearchParams()` returns a `URLSearchParams` directly so
 * callers can `searchParams.get("foo")` straight away. React Router returns
 * `[URLSearchParams, setter]`, which trips legacy callsites with
 * `Cannot read properties of ... .get is not a function`.
 *
 * This shim returns the URLSearchParams. For the rare callsite that needs
 * to mutate, use the raw RR hook directly.
 *
 * Import as: `import { useSearchParams } from "@/hooks/useSearchParams"`
 */
export function useSearchParams(): URLSearchParams {
  const [searchParams] = useRRSearchParams();
  return useMemo(() => searchParams, [searchParams]);
}
